var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pClass.iconSource)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"mr-1 product-class"},'div',attrs,false),on),[_c('img',{staticClass:"product-class-icon",attrs:{"aria-hidden":"","src":_vm.pClass.iconSource,"alt":_vm.pClass.name,"title":_vm.pClass.name}})])]}}],null,false,2098369467)},[_c('span',[_vm._v(_vm._s(_vm.pClass.name))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }